import { useEffect, useState } from 'react'
import { HiPlus, HiTrash, HiCurrencyEuro, HiArrowUp, HiArrowDown, HiCash } from 'react-icons/hi';

const Machine = () => {
    const [amount, setAmount] = useState('');
    const [label, setLabel] = useState('');
    const [expenses, setExpenses] = useState<{
        total: number;
        transactions: {
            id: number;
            amount: number;
            name: string;
            date: string;
        }[]
    }>({
        total: 0,
        transactions: []
    });

    const handleAddExpense = () => {
        if (!amount || !label) {
            return;
        }
        fetch(`${process.env.REACT_APP_BACK_URL}/dispenser`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: parseFloat(amount), name: label })
        })
            .then(response => response.json())
            .then(data => { setExpenses(data); console.log(data); })
            .catch(error => console.error(error));
        setAmount('');
        setLabel('');
    };

    const handleDeleteExpense = (id: number) => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette transaction ?')) return;
        
        fetch(`${process.env.REACT_APP_BACK_URL}/dispenser/${id}`, {
            method: 'DELETE',
        })
            .then(response => response.json())
            .then(data => { setExpenses(data); console.log(data); })
            .catch(error => console.error(error));
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACK_URL}/dispenser`)
            .then(response => response.json())
            .then(data => { setExpenses(data); console.log(data); })
            .catch(error => console.error(error));
    }, []);

    const incomeCount = expenses.transactions.filter(t => t.name === 'Retrait depuis le distributeur').length;
    const expenseCount = expenses.transactions.filter(t => t.name !== 'Retrait depuis le distributeur').length;

    return (
        <>
            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <h1 className="page-title">Suivi Distributeur</h1>
            </div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                <div className={`bg-gradient-to-br ${expenses.total >= 0 ? 'from-emerald-500 to-teal-600' : 'from-rose-500 to-pink-600'} rounded-2xl p-5 text-white shadow-lg`}>
                    <div className="flex items-center gap-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <HiCash className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-white/80 text-sm font-medium">Solde Total</p>
                            <p className="text-2xl font-bold">{expenses.total} €</p>
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl p-5 text-white shadow-lg shadow-emerald-200">
                    <div className="flex items-center gap-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <HiArrowUp className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-emerald-100 text-sm font-medium">Retraits</p>
                            <p className="text-2xl font-bold">{incomeCount}</p>
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl p-5 text-white shadow-lg shadow-rose-200">
                    <div className="flex items-center gap-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <HiArrowDown className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-rose-100 text-sm font-medium">Dépenses</p>
                            <p className="text-2xl font-bold">{expenseCount}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Transaction Card */}
            <div className="card mb-6">
                <div className="p-6 border-b border-slate-200">
                    <h2 className="text-lg font-semibold text-slate-800">Nouvelle Transaction</h2>
                </div>
                <div className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block mb-2 text-sm font-semibold text-slate-700">Montant (€)</label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <HiCurrencyEuro className="w-5 h-5 text-slate-400" />
                                </div>
                                <input
                                    type="number"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    placeholder="0.00"
                                    className="input-modern pl-10"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block mb-2 text-sm font-semibold text-slate-700">Libellé</label>
                            <input
                                type="text"
                                value={label}
                                onChange={(e) => setLabel(e.target.value)}
                                placeholder="Description de la transaction"
                                className="input-modern"
                            />
                        </div>
                    </div>
                    
                    <div className="flex flex-wrap items-center gap-4 mb-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="radio"
                                name="expenseType"
                                value="distributeur"
                                onChange={() => setLabel('Retrait depuis le distributeur')}
                                className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500"
                            />
                            <span className="text-sm text-slate-700 font-medium">Retrait depuis le distributeur</span>
                        </label>
                    </div>
                    
                    <button
                        onClick={handleAddExpense}
                        className="btn-primary flex items-center gap-2"
                        disabled={!amount || !label}
                    >
                        <HiPlus className="w-5 h-5" />
                        Ajouter la transaction
                    </button>
                </div>
            </div>

            {/* Transactions List */}
            <div className="card">
                <div className="p-6 border-b border-slate-200">
                    <h2 className="text-lg font-semibold text-slate-800">Historique des Transactions</h2>
                </div>
                <div className="divide-y divide-slate-100 max-h-96 overflow-y-auto">
                    {expenses.transactions.length > 0 ? (
                        expenses.transactions.map((expense) => {
                            const isIncome = expense.name === 'Retrait depuis le distributeur';
                            return (
                                <div
                                    key={expense.id}
                                    className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors group"
                                >
                                    <div className="flex items-center gap-4">
                                        <div className={`p-3 rounded-xl ${isIncome ? 'bg-emerald-100' : 'bg-rose-100'}`}>
                                            {isIncome ? (
                                                <HiArrowUp className="w-5 h-5 text-emerald-600" />
                                            ) : (
                                                <HiArrowDown className="w-5 h-5 text-rose-600" />
                                            )}
                                        </div>
                                        <div>
                                            <p className="font-medium text-slate-800">{expense.name}</p>
                                            <p className="text-sm text-slate-500">
                                                {new Date(expense.date).toLocaleDateString('fr-FR', {
                                                    day: 'numeric',
                                                    month: 'long',
                                                    year: 'numeric'
                                                })}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <span className={`text-lg font-bold ${isIncome ? 'text-emerald-600' : 'text-rose-600'}`}>
                                            {isIncome ? '+' : '-'}{expense.amount} €
                                        </span>
                                        <button
                                            onClick={() => handleDeleteExpense(expense.id)}
                                            className="p-2 rounded-lg bg-slate-100 text-slate-400 hover:bg-rose-100 hover:text-rose-600 transition-colors opacity-0 group-hover:opacity-100"
                                        >
                                            <HiTrash className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="p-8 text-center">
                            <div className="w-16 h-16 mx-auto mb-4 bg-slate-100 rounded-full flex items-center justify-center">
                                <HiCash className="w-8 h-8 text-slate-400" />
                            </div>
                            <p className="text-slate-500">Aucune transaction pour le moment.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Machine;
